module.exports = __webpack_public_path__ + "img/ctn-2200_image.659f6ed0.png";